import { InputLabel, withStyles } from '@material-ui/core';

export default withStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    paddingBottom: theme.spacing(2),
  },
}))(InputLabel);
